
import {
  fetchSubscriptionsStatus,
  fetchSubscriptionUsers,
} from 'app/api/subscriptions';
import { subscriptions } from 'app/selectors/subscriptions';

export const subscriptionsLoading = state => subscriptions.isLoading(state);

export const preloadSubscriptions = (state, dispatch) => {
  // Load subscription info
  const enabled = subscriptions.isEnabled(state);
  const loading = subscriptions.isLoading(state);
  if (enabled && !loading) {
    return [
      dispatch(fetchSubscriptionsStatus()),
      dispatch(fetchSubscriptionUsers()),
    ];
  }
};



// WEBPACK FOOTER //
// ./app/containers/settings/subscriptions-utils.js